
export default {
  props: ['page'],
};
